import { Injectable } from '@angular/core';
import { GuiComponentApiModel } from '../api/v2/Models/GuiComponentApiModel';
import { SpaContext } from '../../Classes/spacontext';
import { UnitApiService } from '../api/v2/units_api.service';
import { ComponentUnion, IdentityFactoryService } from './identity_factory.service';
import { ComponentIdentityButtonIcon } from './component_identity_button_icon';
import { ComponentIdentityButton } from './component_identity_button';
import { ComponentIdentityImage } from './component_identity_image';
import { ComponentIdentityList } from './component_identity_list';
import { ComponentIdentityRockBottom } from './component_identity_rock_bottom';
import { ComponentIdentityText } from './component_identity_text';

import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';

// https://github.com/VisibaCare/public/pull/105

@Injectable()
export class FlexiblePatientButtonsService {
	public components: any[] = []; // Angular template doesn't work with union idk don't fire me
	// public components: ComponentUnion[] = [];
	public types = {
		componentIdentityButtonIcon: ComponentIdentityButtonIcon,
		componentIdentityButton: ComponentIdentityButton,
		componentIdentityImage: ComponentIdentityImage,
		componentIdentityList: ComponentIdentityList,
		componentIdentityRockBottom: ComponentIdentityRockBottom,
		componentIdentityText: ComponentIdentityText,
	};
	public isLoading = true;

	constructor(
		private readonly spaContext: SpaContext,
		private readonly unitApiService: UnitApiService,
		private readonly identityFactoryService: IdentityFactoryService,
	) {
		// Empty
	}

	public fetchComponents(): void {
		this.isLoading = true;

		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);

		this.unitApiService.getUnitComponents(locationSelectorService.locationUnitId).subscribe(
			({ data }) => {
				this.components = this.parseBackendData(data);
				this.isLoading = false;
			},
			() => {},
		);
	}

	private parseBackendData(data: GuiComponentApiModel[]): ComponentUnion[] {
		return data
			.sort((a, b) => {
				if (a.Order > b.Order) return 1;
				if (a.Order < b.Order) return -1;

				return 0;
			})
			.map((guiComponent) =>
				this.identityFactoryService.produce(guiComponent.Type, {
					id: guiComponent.Id,
					backendMessage: guiComponent.Data,
				}),
			);
	}
}
